import React, { useState } from "react";

const SobreMi = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div style={styles.wrapper}>
      {/* Título y Botón de Control */}
      <div style={styles.header} onClick={() => setIsExpanded(!isExpanded)}>
        <h2 style={styles.title}>Sobre mí</h2>
        <div style={{
          ...styles.icon,
          transform: isExpanded ? "rotate(45deg)" : "rotate(0deg)",
          background: isExpanded ? "#333" : "#ffaf00"
        }}>
          +
        </div>
      </div>

      {/* Contenido Animado */}
      <div style={{
        ...styles.contentWrapper,
        maxHeight: isExpanded ? "1080px" : "0px",
        opacity: isExpanded ? 1 : 0,
      }}>
        <div style={styles.textContainer}>
          <p>¡Hola! Soy <b>Juan Carlos Mancha Ramos</b>, especialista en crear soluciones digitales que combinan <b>diseño atractivo</b> y <b>funcionalidad profesional</b>. Mi objetivo es ayudarte a que tu negocio destaque online, con sitios rápidos, seguros y optimizados.</p>
          
          <p>Ofrezco <b>Desarrollo Web Moderno</b> con <b>React, Next.js, HTML5, CSS3 y JS</b>, creando páginas rápidas y responsivas que brindan una experiencia de usuario excepcional. Cada proyecto está optimizado para rendimiento y conversión.</p>
          
          <p>En <b>CMS y Gestión de Contenidos</b> trabajo con <b>WordPress, Elementor, Avada</b> y otros sistemas, desarrollando blogs, landing pages y subdominios listos para SEO, para que tu contenido llegue a más clientes.</p>
          
          <p>Mis <b>Tiendas Online / E-Commerce</b> en <b>WooCommerce y PrestaShop</b> integran pagos, ERP y formularios React, asegurando checkouts optimizados y transacciones seguras para maximizar tus ventas.</p>
          
          <p>También aplico <b>Inteligencia Artificial</b> en chatbots, asistentes virtuales y análisis predictivo, automatizando marketing y optimizando procesos para que tu negocio trabaje de forma más inteligente.</p>
          
          <p>Finalmente, desarrollo estrategias de <b>Marketing Digital</b>, combinando SEO, Google Ads, redes sociales, email marketing y embudos automatizados para atraer clientes, generar leads y aumentar tus conversiones.</p>
          
          <p>Si buscás un profesional que transforme tu presencia digital en resultados reales, <b>trabajemos juntos</b> y llevemos tu negocio al siguiente nivel.</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    maxWidth: "800px",
    margin: "40px auto",
    padding: "0 20px",
    fontFamily: "'Segoe UI', Roboto, sans-serif",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "15px",
    cursor: "pointer",
    padding: "10px",
    userSelect: "none",
  },
  title: {
    fontSize: "2rem",
    margin: 0,
    color: "#333",
    fontWeight: "700",
  },
  icon: {
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    color: "#fff",
    display: "flex",
	paddingBottom: "4px",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    fontWeight: "bold",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  contentWrapper: {
    overflow: "hidden",
    transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  textContainer: {
    padding: "20px 0",
    textAlign: "justify",
    lineHeight: "1.6",
    color: "#444",
    fontSize: "1.05rem",
  }
};

export default SobreMi;